<template>
    <div class="px-3 py-2">
        <v-form ref="viForm" lazy-validation>
            <b-sidebar id="add_vehicle_inspection" aria-labelledby="sidebar-no-header-title" no-header backdrop width="95%" :style="`direction:`+lang.ldir" right :title="lang.add_vehicle_inspection" shadow>
                <template #default="{ hide }">
                    <div class="m-1 text-start" style="direction:rtl">
                        <div style="width:180px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                            <span>{{ lang.add_vehicle_inspection || 'فحص المركبة الشامل' }}</span>
                            <span v-if="report.report_number"> #{{ report.report_number }}</span>
                        </div>
                        <div @click="hide" id="hideVehicleInspection" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                            <span>{{ lang.close }}</span>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <div class="px-3 py-2" style="direction:rtl">

                        <!-- Inspection info -->
                        <v-row>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.inspection_date || 'تاريخ الفحص' }}</label>
                                <b-form-input class="inborder" type="date" v-model="report.inspection_date" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.inspection_time || 'وقت الفحص' }}</label>
                                <b-form-input class="inborder" type="time" v-model="report.inspection_time" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.inspector_name || 'اسم الفاحص' }}</label>
                                <b-form-input class="inborder" v-model="report.inspector_name" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.inspector_number || 'رقم الفاحص' }}</label>
                                <b-form-input class="inborder" v-model="report.inspector_number" />
                            </v-col>
                        </v-row>

                        <!-- Customer -->
                        <v-row>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.mobile }}</label>
                                <b-form-input class="inborder" v-model="report.customer_mobile" @change="getCustomer()" />
                            </v-col>
                            <v-col cols="12" md="3" sm="6">
                                <label>{{ lang.customer_name }}</label>
                                <b-form-input class="inborder" v-model="report.customer_name" />
                            </v-col>
                            <v-col cols="12" md="3" sm="6">
                                <label>{{ lang.email || 'البريد الإلكتروني' }}</label>
                                <b-form-input class="inborder" v-model="report.customer_email" />
                            </v-col>
                        </v-row>

                        <!-- Vehicle -->
                        <v-row>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.plate_number || 'رقم اللوحة' }}</label>
                                <b-form-input class="inborder" v-model="report.plate_number" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.brand_name || 'الماركة' }}</label>
                                <b-form-input class="inborder" v-model="report.brand" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.car_model || 'الطراز' }}</label>
                                <b-form-input class="inborder" v-model="report.model" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.car_year || 'سنة الصنع' }}</label>
                                <b-form-input class="inborder" v-model="report.made_year" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.car_color || 'اللون' }}</label>
                                <b-form-input class="inborder" v-model="report.color" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.vin_number || 'رقم الهيكل' }}</label>
                                <b-form-input class="inborder" v-model="report.vin" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.engine_number || 'رقم المحرك' }}</label>
                                <b-form-input class="inborder" v-model="report.engine_number" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.odometer || 'قراءة العداد' }}</label>
                                <b-form-input class="inborder" v-model="report.odometer" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.fuel_type || 'نوع الوقود' }}</label>
                                <b-form-select class="selborder" v-model="report.fuel_type" :options="fuelOptions" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6">
                                <label>{{ lang.transmission || 'ناقل الحركة' }}</label>
                                <b-form-select class="selborder" v-model="report.transmission" :options="transmissionOptions" />
                            </v-col>
                        </v-row>

                        <!-- Checklist sections -->
                        <v-row v-for="section in sections" :key="section.key" class="mt-2">
                            <v-col cols="12">
                                <div class="backBlack" style="padding:5px;text-align:center;font-weight:bold;">{{ section.label }}</div>
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th class="backBlack text-center">{{ lang.item_name || 'البند' }}</th>
                                            <th v-for="opt in scaleOptions(section.scale)" :key="opt.value" class="backBlack text-center">{{ opt.label }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in section.items" :key="item.key">
                                            <td>{{ item.label }}</td>
                                            <td v-for="opt in scaleOptions(section.scale)" :key="opt.value" class="text-center">
                                                <input type="radio" :name="section.key+'_'+item.key" :value="opt.value" v-model="findingStatus[section.key][item.key]" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>

                        <!-- Damage diagram -->
                        <v-row class="mt-2">
                            <v-col cols="12">
                                <div class="backBlack" style="padding:5px;text-align:center;font-weight:bold;">{{ lang.damage_diagram || 'رسم تخطيطي للمركبة' }}</div>
                                <div style="padding:8px;text-align:center;">
                                    <span style="font-size:0.85rem;margin-inline-end:8px;">{{ lang.select_damage_type || 'اختر نوع العيب ثم انقر على الرسم:' }}</span>
                                    <b-button
                                        v-for="opt in damageTypes"
                                        :key="opt.value"
                                        size="sm"
                                        :variant="selectedDamageType === opt.value ? 'dark' : 'outline-secondary'"
                                        style="margin:2px;"
                                        @click="selectedDamageType = opt.value"
                                    >{{ opt.symbol }} {{ opt.label }}</b-button>
                                </div>
                                <div style="position:relative;display:inline-block;margin:10px auto;">
                                    <img
                                        ref="diagramImg"
                                        :src="diagramImageSrc"
                                        style="width:500px;max-width:100%;display:block;cursor:crosshair;"
                                        @click="onDiagramClick"
                                    />
                                    <div
                                        v-for="(m, mi) in marks"
                                        :key="mi"
                                        :style="`position:absolute;left:${m.x}%;top:${m.y}%;transform:translate(-50%,-50%);font-weight:bold;font-size:1.1rem;color:red;pointer-events:none;`"
                                    >{{ damageSymbol(m.damage_type) }}</div>
                                </div>
                                <div v-if="marks.length" style="padding:8px;">
                                    <table class="table table-sm" style="font-size:0.85rem;">
                                        <thead><tr><th>{{ lang.view || 'الجهة' }}</th><th>{{ lang.damage_type || 'نوع العيب' }}</th><th></th></tr></thead>
                                        <tbody>
                                            <tr v-for="(m, mi) in marks" :key="mi">
                                                <td>{{ viewLabel(m.view) }}</td>
                                                <td>{{ damageSymbol(m.damage_type) }} {{ damageLabel(m.damage_type) }}</td>
                                                <td><b-button size="sm" variant="danger" @click="marks.splice(mi,1)">{{ lang.delete }}</b-button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </v-col>
                        </v-row>

                        <!-- Overall rating -->
                        <v-row class="mt-2">
                            <v-col cols="12">
                                <div class="backBlack" style="padding:5px;text-align:center;font-weight:bold;">{{ lang.overall_rating || 'التقييم النهائي' }}</div>
                                <div style="padding:10px;">
                                    <label v-for="opt in ratingOptions" :key="opt.value" style="margin-inline-end:20px;">
                                        <input type="radio" name="overall_rating" :value="opt.value" v-model="report.overall_rating" />
                                        {{ opt.label }}
                                    </label>
                                </div>
                            </v-col>
                        </v-row>

                        <!-- Notes -->
                        <v-row>
                            <v-col cols="12">
                                <label>{{ lang.notes || 'ملاحظات إضافية / توصيات' }}</label>
                                <b-form-textarea class="inborder" v-model="report.notes" rows="3" />
                            </v-col>
                        </v-row>

                        <!-- Phase 4: select specific findings and convert them into a
                             new document. Only offered once the report is saved (the
                             list below is built from findingStatus, so it only ever
                             shows items the technician actually evaluated) -- staff
                             pick whichever of those they want billed, unlike the older
                             checkup system's all-or-nothing convert. -->
                        <v-row v-if="report.id">
                            <v-col cols="12">
                                <div class="backBlack" style="padding:5px;text-align:center;font-weight:bold;">{{ lang.convert_findings || 'تحويل البنود المحددة' }}</div>
                                <div style="max-height:220px;overflow-y:auto;border:1px solid #ccc;padding:8px;">
                                    <div v-for="f in buildFindings()" :key="f.section+'_'+f.item_key" style="padding:2px 0;">
                                        <label style="cursor:pointer;">
                                            <input type="checkbox" v-model="selected[f.section+'_'+f.item_key]" />
                                            {{ f.item_label }} — <span style="color:#666;">{{ findingStatusLabel(f) }}</span>
                                        </label>
                                    </div>
                                    <div v-if="buildFindings().length === 0" style="color:#888;">{{ lang.no_findings || 'لا توجد بنود مقيّمة بعد' }}</div>
                                </div>
                                <div style="text-align:center;margin-top:8px;">
                                    <b-button variant="light" style="background:darkslategrey;color:#fff;width:170px;margin:3px;" :disabled="!selectedCount" @click="convertTo('card')" v-b-toggle.add_new_card>{{ lang.add_maint_request || 'تحويل إلى أمر عمل' }}</b-button>
                                    <b-button variant="light" style="background:green;color:#fff;width:170px;margin:3px;" :disabled="!selectedCount" @click="convertTo('invoice')" v-b-toggle.add_invoice>{{ lang.add_invoice || 'تحويل إلى فاتورة' }}</b-button>
                                    <b-button variant="light" style="background:darkblue;color:#fff;width:170px;margin:3px;" :disabled="!selectedCount" @click="convertTo('quotation')" v-b-toggle.add_quotation>{{ lang.add_quotation || 'تحويل إلى عرض سعر' }}</b-button>
                                </div>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" class="text-center">
                                <div v-if="message" style="margin-bottom:8px;color:#0a8a3f;">{{ message }}</div>
                                <b-button variant="light" style="background:blue;color:#fff;width:150px;" :disabled="busy" @click="save()">{{ lang.save }}</b-button>
                                <b-button v-if="report.id" variant="success" style="width:180px;margin-inline-start:10px;" :disabled="sendBusy" @click="sendToCustomer()">{{ lang.send_to_customer || 'إرسال للعميل واتساب' }}</b-button>
                                <div v-if="report.whatsapp_sent_date" style="margin-top:6px;color:#0a8a3f;font-size:0.9rem;">{{ lang.report_sent_on || 'تم الإرسال بتاريخ' }}: {{ report.whatsapp_sent_date }}</div>
                                <div v-if="sendMessage" style="margin-top:6px;font-size:0.9rem;">{{ sendMessage }}</div>
                            </v-col>
                        </v-row>

                        <addNewCard ref="viCard" />
                        <addInvoice ref="viInvoice" />
                        <AddQuotation ref="viQuot" :cust="custo" />

                    </div>
                </template>
            </b-sidebar>
        </v-form>
    </div>
</template>

<script>
import axios from 'axios'
import addNewCard from '@/components/addNewCard.vue'
import addInvoice from '@/components/addInvoice.vue'
import AddQuotation from '@/components/addQuotation.vue'

// Transcribed from the reference form (نموذج فحص المركبة الشامل). Wording
// can be tweaked freely later -- item_label is denormalized into each saved
// finding row, so changing this list only affects future reports.
const SECTIONS = [
    { key: 'interior', label: 'الفحص الداخلي', scale: 'ok_needs', items: [
        { key: 'seats', label: 'المقاعد' },
        { key: 'seatbelts', label: 'أحزمة الأمان' },
        { key: 'dashboard', label: 'الطبلون' },
        { key: 'gauges', label: 'الشاشة والعدادات' },
        { key: 'ac', label: 'المكيف' },
        { key: 'electric_windows', label: 'النوافذ الكهربائية' },
        { key: 'airbags', label: 'الوسائد الهوائية' },
        { key: 'interior_lighting', label: 'الإضاءة الداخلية' },
        { key: 'entertainment', label: 'الصوت / النظام الترفيهي' },
        { key: 'rear_camera', label: 'الكاميرا الخلفية' },
        { key: 'parking_sensors', label: 'حساسات الوقوف' },
        { key: 'cleanliness', label: 'حالة النظافة' },
    ]},
    { key: 'exterior', label: 'الفحص الخارجي (البودي)', scale: 'ok_needs', items: [
        { key: 'front_bumper', label: 'الصدام الأمامي' },
        { key: 'front_right_fender', label: 'الرفرف الأمامي (يمين)' },
        { key: 'front_right_door', label: 'الباب الأمامي (يمين)' },
        { key: 'rear_right_door', label: 'الباب الخلفي (يمين)' },
        { key: 'rear_right_fender', label: 'الرفرف الخلفي (يمين)' },
        { key: 'roof', label: 'السقف' },
        { key: 'front_left_fender', label: 'الرفرف الأمامي (يسار)' },
        { key: 'front_left_door', label: 'الباب الأمامي (يسار)' },
        { key: 'rear_left_door', label: 'الباب الخلفي (يسار)' },
        { key: 'rear_left_fender', label: 'الرفرف الخلفي (يسار)' },
        { key: 'rear_bumper', label: 'الصدام الخلفي' },
        { key: 'front_windshield', label: 'الزجاج الأمامي' },
        { key: 'rear_windshield', label: 'الزجاج الخلفي' },
        { key: 'side_mirrors', label: 'المرايا الجانبية' },
        { key: 'exterior_lighting', label: 'الإنارة الخارجية' },
    ]},
    { key: 'engine', label: 'المحرك والأنظمة', scale: 'ok_needs', items: [
        { key: 'engine_start', label: 'تشغيل المحرك' },
        { key: 'engine_sounds', label: 'أصوات المحرك' },
        { key: 'oil_leak', label: 'تسريب زيت' },
        { key: 'water_leak', label: 'تسريب ماء' },
        { key: 'battery', label: 'البطارية' },
        { key: 'belts', label: 'السيور' },
        { key: 'radiator', label: 'الرديتر' },
        { key: 'air_filter', label: 'فلتر الهواء' },
        { key: 'exhaust', label: 'نظام العادم' },
    ]},
    { key: 'suspension_brakes', label: 'نظام التعليق والفرامل', scale: 'ok_needs', items: [
        { key: 'shocks', label: 'المساعدات' },
        { key: 'arms', label: 'الأذرعة' },
        { key: 'front_brakes', label: 'الفرامل الأمامية' },
        { key: 'rear_brakes', label: 'الفرامل الخلفية' },
        { key: 'hubs', label: 'الهوبات / الدسك' },
        { key: 'tires', label: 'الإطارات' },
        { key: 'tire_pressure', label: 'ضغط الإطارات' },
        { key: 'rims', label: 'الجنوط' },
        { key: 'spare_tire', label: 'حالة الاستبينة' },
    ]},
    { key: 'fluids', label: 'السوائل', scale: 'fluid', items: [
        { key: 'engine_oil', label: 'زيت المحرك' },
        { key: 'gearbox_oil', label: 'زيت القير' },
        { key: 'brake_fluid', label: 'زيت الفرامل' },
        { key: 'coolant', label: 'سائل التبريد' },
        { key: 'power_steering_fluid', label: 'زيت الدركسيون' },
        { key: 'washer_fluid', label: 'ماء المساحات' },
    ]},
    { key: 'electronics', label: 'الفحص الإلكتروني', scale: 'yes_no', items: [
        { key: 'ecu_lamp', label: 'لمبة المحرك' },
        { key: 'abs_lamp', label: 'لمبة ABS' },
        { key: 'airbag_lamp', label: 'لمبة الوسائد الهوائية' },
        { key: 'other_faults', label: 'أعطال أخرى' },
        { key: 'computer_scan', label: 'تم فحص الكمبيوتر' },
    ]},
    { key: 'test_drive', label: 'تجربة القيادة', scale: 'test_drive', items: [
        { key: 'acceleration', label: 'التسارع' },
        { key: 'transmission', label: 'ناقل الحركة' },
        { key: 'brakes', label: 'الفرامل' },
        { key: 'road_stability', label: 'الثبات على الطريق' },
        { key: 'unusual_sounds', label: 'أصوات غير طبيعية' },
    ]},
    { key: 'accessories', label: 'الملحقات', scale: 'yes_no', items: [
        { key: 'spare_key', label: 'مفتاح احتياطي' },
        { key: 'owner_manual', label: 'كتيب السيارة' },
        { key: 'basic_tools', label: 'العدة الأساسية' },
        { key: 'fire_extinguisher', label: 'طفاية حريق' },
        { key: 'warning_triangle', label: 'مثلث تحذيري' },
        { key: 'first_aid', label: 'شنطة إسعافات أولية' },
    ]},
];

const SCALES = {
    ok_needs: [ { value: 'ok', label: 'سليم' }, { value: 'needs_repair', label: 'يحتاج إصلاح' } ],
    fluid: [ { value: 'good', label: 'جيد' }, { value: 'needs', label: 'يحتاج' }, { value: 'unavailable', label: 'غير متوفر' } ],
    yes_no: [ { value: 'yes', label: 'نعم' }, { value: 'no', label: 'لا' } ],
    test_drive: [ { value: 'needs_check', label: 'بحاجة فحص' }, { value: 'good', label: 'جيد' }, { value: 'excellent', label: 'ممتاز' } ],
};

function blankFindingStatus(){
    const out = {};
    SECTIONS.forEach((s) => {
        out[s.key] = {};
        s.items.forEach((it) => { out[s.key][it.key] = ''; });
    });
    return out;
}

// The 4 "views" the reference form calls for are all present in one
// existing composite image (public/img/car-background.png -- top-down
// center, side profile at bottom, narrow front/rear panels on the sides;
// already used elsewhere for a plain freehand sketch, see addCarScetch.vue)
// rather than 4 separate assets. A click is classified into a view by which
// rough region of that one image it landed in -- approximate, but only
// needed for organizing/labeling marks, not pixel-perfect geometry.
const DIAGRAM_REGIONS = [
    { view: 'front', xMin: 0, xMax: 20, yMin: 20, yMax: 75 },
    { view: 'rear', xMin: 80, xMax: 100, yMin: 20, yMax: 75 },
    { view: 'side', xMin: 0, xMax: 100, yMin: 68, yMax: 100 },
    { view: 'top', xMin: 20, xMax: 80, yMin: 0, yMax: 68 },
];

const DAMAGE_TYPES = [
    { value: 'scratch', label: 'خدش', symbol: '○' },
    { value: 'dent', label: 'صدمة / انبعاج', symbol: '✕' },
    { value: 'paint', label: 'دهان', symbol: '□' },
    { value: 'replace', label: 'استبدال', symbol: '△' },
    { value: 'crack', label: 'تشقق', symbol: '~' },
    { value: 'other', label: 'أخرى', symbol: '---' },
];

const VIEW_LABELS = { top: 'علوي', front: 'أمامي', side: 'جانبي', rear: 'خلفي' };

export default {
    name: 'AddVehicleInspectionReport',
    components: { addNewCard, addInvoice, AddQuotation },
    data() {
        return {
            sections: SECTIONS,
            report: this.blankReport(),
            findingStatus: blankFindingStatus(),
            marks: [],
            damageTypes: DAMAGE_TYPES,
            selectedDamageType: 'scratch',
            busy: false,
            message: '',
            sendBusy: false,
            sendMessage: '',
            selected: {},
            custo: '',
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki) == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki) == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        fuelOptions(){
            return [
                { value: '', text: '-' },
                { value: 'petrol', text: 'بنزين' },
                { value: 'diesel', text: 'ديزل' },
                { value: 'hybrid', text: 'هايبرد' },
                { value: 'electric', text: 'كهرباء' },
            ];
        },
        transmissionOptions(){
            return [
                { value: '', text: '-' },
                { value: 'automatic', text: 'أوتوماتيك' },
                { value: 'manual', text: 'عادي' },
            ];
        },
        ratingOptions(){
            return [
                { value: 'excellent', label: 'ممتاز' },
                { value: 'very_good', label: 'جيدة جداً' },
                { value: 'good', label: 'جيدة' },
                { value: 'acceptable', label: 'مقبولة' },
                { value: 'needs_major_repair', label: 'تحتاج إصلاحات كبيرة' },
            ];
        },
        diagramImageSrc(){
            return process.env.BASE_URL + 'img/car-background.png';
        },
        selectedCount(){
            return Object.values(this.selected).filter(Boolean).length;
        },
    },
    methods: {
        damageSymbol(val){
            const found = DAMAGE_TYPES.find((d) => d.value === val);
            return found ? found.symbol : '?';
        },
        damageLabel(val){
            const found = DAMAGE_TYPES.find((d) => d.value === val);
            return found ? found.label : val;
        },
        viewLabel(val){
            return VIEW_LABELS[val] || val;
        },
        classifyView(xPct, yPct){
            const match = DIAGRAM_REGIONS.find((r) => xPct >= r.xMin && xPct <= r.xMax && yPct >= r.yMin && yPct <= r.yMax);
            return match ? match.view : 'top';
        },
        onDiagramClick(event){
            const img = this.$refs.diagramImg;
            if(!img) return;
            const rect = img.getBoundingClientRect();
            const xPct = ((event.clientX - rect.left) / rect.width) * 100;
            const yPct = ((event.clientY - rect.top) / rect.height) * 100;
            this.marks.push({
                view: this.classifyView(xPct, yPct),
                x: Math.round(xPct * 100) / 100,
                y: Math.round(yPct * 100) / 100,
                damage_type: this.selectedDamageType,
                note: '',
            });
        },
        scaleOptions(scale){
            return SCALES[scale] || [];
        },
        findingStatusLabel(f){
            const section = this.sections.find((s) => s.key === f.section);
            const opt = section ? (SCALES[section.scale] || []).find((o) => o.value === f.status) : null;
            return opt ? opt.label : f.status;
        },
        blankReport(){
            return {
                id: 0, report_number: '', inspection_date: '', inspection_time: '',
                inspector_name: '', inspector_number: '',
                customer_id: 0, customer_name: '', customer_mobile: '', customer_email: '',
                plate_number: '', brand: '', model: '', made_year: '', color: '', vin: '',
                engine_number: '', fuel_type: '', transmission: '', odometer: '',
                overall_rating: '', notes: '',
            };
        },
        resetAll(){
            this.report = this.blankReport();
            this.findingStatus = blankFindingStatus();
            this.marks = [];
            this.message = '';
            this.selected = {};
        },
        getCustomer(){
            const post = new FormData();
            post.append('type', 'getCustomerMob');
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[mobile]', this.report.customer_mobile);
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                const c = response && response.data && response.data.results ? response.data.results.data : null;
                if(c && c.id){
                    this.report.customer_id = c.id;
                    this.report.customer_name = c.full_name || this.report.customer_name;
                }
            });
        },
        async loadReport(id){
            const post = new FormData();
            post.append('type', 'getVehicleInspectionReports');
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]', id);
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
            const rows = response && response.data && response.data.results ? response.data.results.data : [];
            if(!rows || !rows.length) return;
            const r = rows[0];
            if(Number(this.report.id) !== Number(r.id)){
                this.selected = {};
            }
            this.report = { ...this.blankReport(), ...r };
            this.findingStatus = blankFindingStatus();
            (r.findings || []).forEach((f) => {
                if(this.findingStatus[f.section] !== undefined){
                    this.findingStatus[f.section][f.item_key] = f.status;
                }
            });
            this.marks = (r.marks || []).map((m) => ({
                view: m.view, x: Number(m.x), y: Number(m.y), damage_type: m.damage_type, note: m.note || '',
            }));
        },
        buildFindings(){
            const out = [];
            this.sections.forEach((s) => {
                s.items.forEach((it) => {
                    const status = this.findingStatus[s.key][it.key];
                    if(status){
                        out.push({ section: s.key, item_key: it.key, item_label: it.label, status });
                    }
                });
            });
            return out;
        },
        async save(){
            this.busy = true;
            this.message = '';
            const post = new FormData();
            post.append('type', 'addVehicleInspectionReport');
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]', this.report.id);
            post.append('data[inspection_date]', this.report.inspection_date);
            post.append('data[inspection_time]', this.report.inspection_time);
            post.append('data[inspector_name]', this.report.inspector_name);
            post.append('data[inspector_number]', this.report.inspector_number);
            post.append('data[customer_id]', this.report.customer_id || 0);
            post.append('data[customer_name]', this.report.customer_name);
            post.append('data[customer_mobile]', this.report.customer_mobile);
            post.append('data[customer_email]', this.report.customer_email);
            post.append('data[plate_number]', this.report.plate_number);
            post.append('data[brand]', this.report.brand);
            post.append('data[model]', this.report.model);
            post.append('data[made_year]', this.report.made_year);
            post.append('data[color]', this.report.color);
            post.append('data[vin]', this.report.vin);
            post.append('data[engine_number]', this.report.engine_number);
            post.append('data[fuel_type]', this.report.fuel_type);
            post.append('data[transmission]', this.report.transmission);
            post.append('data[odometer]', this.report.odometer);
            post.append('data[overall_rating]', this.report.overall_rating);
            post.append('data[notes]', this.report.notes);
            const findings = this.buildFindings();
            findings.forEach((f, i) => {
                post.append(`data[findings][${i}][section]`, f.section);
                post.append(`data[findings][${i}][item_key]`, f.item_key);
                post.append(`data[findings][${i}][item_label]`, f.item_label);
                post.append(`data[findings][${i}][status]`, f.status);
            });
            this.marks.forEach((m, i) => {
                post.append(`data[marks][${i}][view]`, m.view);
                post.append(`data[marks][${i}][x]`, m.x);
                post.append(`data[marks][${i}][y]`, m.y);
                post.append(`data[marks][${i}][damage_type]`, m.damage_type);
                post.append(`data[marks][${i}][note]`, m.note || '');
            });
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
            this.busy = false;
            if(response && response.data && response.data.error && response.data.error.number === 200){
                this.message = this.lang.saved || 'تم الحفظ بنجاح';
                if(response.data.results && response.data.results.data && response.data.results.data.id){
                    this.report.id = response.data.results.data.id;
                }
                this.$emit('saved');
            }else{
                this.message = 'error';
            }
        },
        async sendToCustomer(){
            if(!this.report.id) return;
            this.sendBusy = true;
            this.sendMessage = '';
            const post = new FormData();
            post.append('type', 'sendVehicleInspectionReport');
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]', this.report.id);
            try {
                const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
                const res = response && response.data;
                if(res && res.error && res.error.number === 200){
                    this.sendMessage = this.lang.sent_ok || 'تم الإرسال بنجاح';
                    await this.loadReport(this.report.id);
                }else{
                    this.sendMessage = (res && res.error && res.error.message) || 'error';
                }
            } catch (e) {
                this.sendMessage = 'error';
            }
            this.sendBusy = false;
        },
        // Phase 4: selective convert. Each target component (addNewCard/
        // addInvoice/AddQuotation) is a large, independently-used shared
        // component with its own field names and its own splitPlate() --
        // rather than duplicating that parsing logic here, we call each
        // ref's own splitPlate() and reuse its own getAllName()/getName()
        // customer-lookup method, exactly like the existing checkup-convert
        // and contract-convert flows already do elsewhere in this app.
        async convertTo(target){
            const findings = this.buildFindings().filter((f) => this.selected[f.section + '_' + f.item_key]);
            if(!findings.length) return;
            if(target === 'card') await this.convertToCard(findings);
            else if(target === 'invoice') await this.convertToInvoice(findings);
            else if(target === 'quotation') await this.convertToQuotation(findings);
        },
        fillCar(ref, carsKey){
            this.$set(ref[carsKey][0], 'plate_number', this.report.plate_number);
            this.$set(ref[carsKey][0], 'brand', this.report.brand);
            this.$set(ref[carsKey][0], 'model', this.report.model);
            this.$set(ref[carsKey][0], 'made_year', this.report.made_year);
            this.$set(ref[carsKey][0], 'color', this.report.color);
            this.$set(ref[carsKey][0], 'vin', this.report.vin);
            const pl = ref.splitPlate(this.report.plate_number || '');
            this.$set(ref[carsKey][0], 'c1', pl[0] || '');
            this.$set(ref[carsKey][0], 'c2', pl[1] || '');
            this.$set(ref[carsKey][0], 'c3', pl[2] || '');
        },
        async convertToCard(findings){
            const ref = this.$refs.viCard;
            await ref.resetValues();
            await ref.getInvSettings();
            ref.customer.mobile = this.report.customer_mobile;
            ref.customer.full_name = this.report.customer_name;
            ref.customer.id = this.report.customer_id || 0;
            ref.customer.customerid = this.report.customer_id || '';
            ref.getAllName(1);
            this.fillCar(ref, 'cars');
            this.$set(ref.cars[0], 'nums', ref.splitPlate(this.report.plate_number || '')[3] || '');
            ref.tbrows = findings.map((f) => ({
                empname: '', itemcode: '', item_name: f.item_label, qty: 1,
                item_price: 0, total: 0, vat: 0, ftotal: 0,
                plate_number: this.report.plate_number, workers_name: [], brand: '',
            }));
        },
        async convertToInvoice(findings){
            const ref = this.$refs.viInvoice;
            await ref.getNewInvoiceID();
            ref.reset1();
            ref.customer.mobile = this.report.customer_mobile;
            ref.customer.full_name = this.report.customer_name;
            ref.customer.id = this.report.customer_id || 0;
            ref.customer.customerid = this.report.customer_id || '';
            ref.getAllName(1);
            this.fillCar(ref, 'cars');
            this.$set(ref.cars[0], 'text', ref.splitPlate(this.report.plate_number || '')[3] || '');
            ref.tbrows = findings.map((f) => ({
                empname: '', itemcode: '', item_name: f.item_label, qty: 1,
                item_price: 0, total: 0, vat: 0, ftotal: 0,
                plate_number: this.report.plate_number, workers_name: [], brand: '', unitid: 1,
            }));
        },
        async convertToQuotation(findings){
            const ref = this.$refs.viQuot;
            await ref.reset();
            ref.id = 0;
            ref.customer.mobile = this.report.customer_mobile;
            ref.customer.full_name = this.report.customer_name;
            ref.customer.id = this.report.customer_id || 0;
            ref.getName(1);
            this.fillCar(ref, 'cars');
            this.$set(ref.cars[0], 'text', ref.splitPlate(this.report.plate_number || '')[3] || '');
            ref.tbrows = findings.map((f) => ({
                perDisc: 0, id: 0, empname: '', itemcode: '', description: '',
                item_name: f.item_label, qty: 1, item_price: 0, total: 0, vat: 0, ftotal: 0,
                discount: 0, plate_number: this.report.plate_number, workers_name: [], brand: '',
            }));
        },
    },
}
</script>
